// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"396":"05ab3dac","512":"bab071e6","836":"1c1d5c75"}[chunkId] + ".chunk.css";
};